import Picker from './Picker';
import DataSource from './DataSource';

Picker.DataSource = DataSource;
Picker.Threshold = DataSource.Threshold;

export default Picker;